var map = {
	"./balloon-architecture-1.svg": 119,
	"./balloon-architecture-2.svg": 120,
	"./balloon-architecture-3.svg": 121,
	"./balloon-architecture-4.svg": 122,
	"./balloon-civil-1.svg": 123,
	"./balloon-civil-2.svg": 124,
	"./balloon-civil-3.svg": 125,
	"./balloon-energy-1.svg": 126,
	"./balloon-energy-2.svg": 127,
	"./balloon-future-1.svg": 128,
	"./balloon-future-2.svg": 129,
	"./balloon-lab-1.svg": 130,
	"./balloon-lab-2.svg": 131,
	"./balloon-lab-3.svg": 132,
	"./balloon-mokkou-1.svg": 133,
	"./balloon-mokkou-2.svg": 134
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 118;


//////////////////
// WEBPACK FOOTER
// ./resources/images/balloons nonrecursive \.(svg)$
// module id = 118
// module chunks = 0